import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Row } from 'antd'
import { Company } from '../../component'
import '../../css/company.scss'

const { ActionBar, Table } = Company

const Companies = (props) => {
  return (
    <Row className='customersRow'>
      <Col flex={'auto'}>
        <ActionBar />
        <Table />
      </Col>
    </Row>
  )
}

Companies.propTypes = {}

export default connect(null, null)(Companies)
